import { isEqual } from 'lodash-es';
import types from './types';
import { updateByKey } from '../../utils';

const initialState = {
  polling: true,
  isLoading: {
    jobs: false,
    job: false,
    logs: false,
    jobAction: false
  },
  errors: {
    jobs: false,
    job: false,
    logs: false,
    jobAction: false
  },
  data: {
    jobs: [],
    jobSelected: false,
    logs: []
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_ALL_JOBS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          jobs: true
        }
      };
    case types.GET:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          job: true
        },
        data: {
          ...state.data,
          jobSelected: {
            jobKey: {
              group: action.group,
              name: action.name
            }
          }
        }
      };
    case types.RESUME:
    case types.TRIGGER:
    case types.STOP:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          jobAction: true
        }
      };
    case types.GET_ALL_JOBS_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          jobs: [...action.data]
        },
        errors: {
          ...state.errors,
          jobs: false
        },
        isLoading: {
          ...state.isLoading,
          jobs: false
        }
      };
    case types.GET_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          jobSelected: false
        },
        errors: {
          ...state.errors,
          jobSelected: false
        },
        data: {
          jobs: updateByKey(state.data.jobs, action.data, 'jobKey'),
          jobSelected: action.data
        }
      };
    case types.RESUME_SUCCESS:
    case types.TRIGGER_SUCCESS:
    case types.STOP_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          jobAction: false
        },
        errors: {
          ...state.errors,
          jobAction: false
        },
        data: {
          jobs: updateByKey(state.data.jobs, action.data, 'jobKey'),
          jobSelected:
            state.data.jobSelected && isEqual(state.data.jobSelected.jobKey, action.data.jobKey)
              ? action.data
              : state.data.jobSelected
        }
      };
    case types.GET_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          jobLoading: false
        },
        errors: {
          ...state.errors,
          jobSelected: action.error
        }
      };
    case types.GET_ALL_JOBS_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          jobs: false
        },
        errors: {
          ...state.errors,
          jobs: action.error
        }
      };
    case types.RESUME_FAILURE:
    case types.TRIGGER_FAILURE:
    case types.STOP_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          jobAction: false
        }
      };
    default:
      return { ...state };
  }
}
